if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.removeItem();
      });
    }

    removeItem() {
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      if (cartItems) {
        cartItems.updateQuantity(this.dataset.index, 0);
      } else {
        const newCartStructure = this.closest('.shopping-cart__table');
        if (newCartStructure) {
          const body = JSON.stringify({
            id: this.dataset.index,
            quantity: 0
          });

          fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((parsedState) => {
              this.closest('.shopping-cart__row').remove();
              this.updateCartState(parsedState);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      }

      if (typeof cartUpdated === 'function') {
        cartUpdated();
      }
    }

    updateCartState(parsedState) {
      const cartItemCount = parsedState.item_count;
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
      const cartItems = document.querySelector('cart-items');

      const cartCountBubble = document.getElementById('cart-icon-bubble');
      if (cartCountBubble) {
        cartCountBubble.innerHTML = cartItemCount;
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartItemCount } }));
    }
  }

  customElements.define('cart-remove-button', CartRemoveButton);
}

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      // Enter (o "Ir" en el teclado de Android) en la cantidad no tiene que mandar al checkout:
      // el input está dentro de form#cart y el primer submit de ese form es CHECKOUT.
      // Se confirma la cantidad saliendo del campo, que dispara el change.
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.target.name !== 'updates[]') return;
        event.preventDefault();
        event.target.blur();
      });
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        }
      ];
    }

    updateQuantity(line, quantity, name) {
      this.enableLoading(line);
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      let stateString;
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          stateString = state;
          return CartJS.getCart();
        })
        .then((cartJsResponse) => {
          const parsedState = JSON.parse(stateString);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (!parsedState.sections) throw new Error(parsedState.description || parsedState.message || 'Cart update failed');

          // Solo las secciones que existen en esta página: /cart usa el header simple, sin
          // cart-icon-bubble. Si una falta, el resto (la barra del total incluida) igual se actualiza.
          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            const html = parsedState.sections[section.section];
            if (!container || !html) return;
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
            if (!fresh) return;
            (container.querySelector(section.selector) || container).innerHTML = fresh.innerHTML;
          });

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
          if (typeof cartUpdated === 'function') cartUpdated();
          this.disableLoading(line);
        })
        .catch((error) => {
          console.error('Error updating cart:', error);
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = (error && error.message) || window.cartStrings.error;
          this.disableLoading(line);
        });
    }

    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const errorText = lineItemError && lineItemError.querySelector('.cart-item__error-text');
        if (errorText && quantityElement) {
          errorText.innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
        }
      }

      this.currentItemCount = itemCount;
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      if (!cartStatus) return;
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.add('cart__items--disabled');

      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

      document.activeElement.blur();
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.remove('cart__items--disabled');

      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }

  customElements.define('cart-items', CartItems);
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.duration = (parseInt(this.getAttribute("data-duration"), 10) || 10) * 60;

      this.storageKey = this.getAttribute("data-storage-key")
        || `countdown-${this.id || Math.random().toString(36).slice(2)}`;

      this.formatType = this.getAttribute("format") || "mm:ss";

      this.display = this.querySelector("span[data-countdown-display]");
    }

    connectedCallback() {
      const saved = parseInt(localStorage.getItem(this.storageKey), 10);
      this.timeLeft = saved > 0 ? saved : this.duration;

      this.updateDisplay();

      this.observer = new IntersectionObserver(
        ([entry]) => entry.isIntersecting ? this.start() : this.stop(),
        { threshold: 0.1 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
    }

    start() {
      if (this.interval) return;
      this.interval = setInterval(() => this.tick(), 1000);
    }

    stop() {
      if (!this.interval) return;
      clearInterval(this.interval);
      this.interval = null;
    }

    reset() {
      this.timeLeft = this.duration;
      this.updateDisplay();
      localStorage.setItem(this.storageKey, this.timeLeft);
    }

    restart() {
      this.reset();
    }

    tick() {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.updateDisplay();
        localStorage.setItem(this.storageKey, this.timeLeft);
        this.dispatchEvent(new CustomEvent("timer-tick", { detail: this.timeLeft }));
      } else {
        if (this.hasAttribute("autoloop")) {
          this.restart();
        } else {
          this.stop();
          if (this.hasAttribute("autoclear")) {
            localStorage.removeItem(this.storageKey);
          }
        }
      }
    }

    updateDisplay() {
      this.display.textContent = this.formatTime(this.timeLeft);
    }

    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      seconds = seconds % 60;

      switch (this.formatType.toLowerCase()) {
        case "hh:mm:ss":
          return `${hours.toString().padStart(2,"0")}:${minutes.toString().padStart(2,"0")}:${seconds.toString().padStart(2,"0")}`;
        case "mm:ss":
          return `${minutes.toString().padStart(2,"0")}:${seconds.toString().padStart(2,"0")}`;
        case "verbose":
          return `${hours ? hours+"h " : ""}${minutes ? minutes+"m " : ""}${seconds}s`;
        default:
          return `${minutes}:${seconds.toString().padStart(2,"0")}`;
      }
    }
  })
}

// Ocultar el cart drawer (no mostrarlo en la tienda)
(function() {
  var style = document.createElement('style');
  style.textContent = 'cart-drawer { display: none !important; }';
  document.head.appendChild(style);
})();
